import CarouselItem from './carousel-item';
import Carousel from './carousel';
Carousel.Item = CarouselItem;
export default Carousel;
//# sourceMappingURL=index.js.map